enum Header {
  // TODO: Note that for this to work effectively, the header casing does matter. The spring services key off this
  // string to show up in logs. Top tip: you can set this header yourself to a known identifier to make debugging easier
  // and to be sure any distributed request chain results from a request originated by you.
  CORRELATION_HEADER = 'x-cid',
  ATTRIBUTION_HEADER = 'Auction-Graph-Source',
  XSRF_HEADER = 'X-XSRF-TOKEN',
}

export default Header
